import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-svg-bigbag',
  templateUrl: './svg-bigbag.component.html',
  styleUrls: ['./svg-bigbag.component.css']
})
export class SvgBigbagComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
